import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@material-ui/core"
import { VisibilityOffOutlined, VisibilityOutlined } from "@material-ui/icons"
import AppContext from "contexts/App"
import ClerkAppContext from "contexts/Clerk/ClerkApp"
import { Form, Formik } from "formik"
import { useContext, useState } from "react"
import { useRef } from "react"
import * as Yup from "yup"

import useStyles from "./styles"

const FinishAccount = () => {
  const classes = useStyles()

  const { dialogs, closeDialog, openSnackBar } = useContext(AppContext)
  const { changePasswordMutation } = useContext(ClerkAppContext)
  const thisDialog = dialogs?.["finishAccount"] || {}
  const { open = false, data = {} } = thisDialog
  let token = data?.token

  const formRef = useRef()
  const [passwordVisibility, setPasswordVisibility] = useState(false)
  const [confirmedNewPasswordVisibility, setConfirmedNewPasswordVisibility] =
    useState(false)
  const [loading, setLoading] = useState(false)

  const schema = Yup.object().shape({
    password: Yup.string()
      .required("Password is required")
      .matches(
        /^(?=.*[\d])(?=.*[!@#$%^&*()_\-+={[}\]|\\:;"'<,>.?/])(?=.*[A-Z])[A-Za-z\d!@#$%^&*()_\-+={[}\]|\\:;"'<,>.?/]{8,}$/,
        "Requirements: 8 characters, 1 Upper Case & 1 special character"
      ),
    confirmedPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .min(6, "Password has to have at least 6 characters"),
  })

  const handleClose = () => {
    closeDialog("finishAccount")
    setPasswordVisibility(false)
    setConfirmedNewPasswordVisibility(false)
  }
  const onSubmit = (values, actions) => {
    setLoading(true)
    let data = { approved_token: token, password: values?.password }
    changePasswordMutation
      .mutateAsync(data)
      .then((res) => {
        openSnackBar({ message: "Password updated" })
        setLoading(false)
        handleClose()
      })
      .catch((err) => {
        console.log(err)
        openSnackBar({ message: "Error creating password" })
        setLoading(false)
      })
  }

  return (
    <Dialog open={open} classes={{ paperWidthSm: classes.paper }}>
      <DialogTitle disableTypography>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Typography variant="h2" className={classes.title}>
            Finish Account
          </Typography>
          <Typography>
            Thank you for joining MatchBoard. Please add a password to complete
            you account set up
          </Typography>
          <Typography style={{ fontSize: "1.2rem" }}>
            *Password must contain at least 8 characters, one uppercase letter,
            one number, and one special character
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Formik
          initialValues={{
            password: "",
            confirmedPassword: "",
          }}
          onSubmit={onSubmit}
          validationSchema={schema}
          innerRef={formRef}
        >
          {({
            handleChange,
            values,
            errors,
            touched,
            handleBlur,
            isSubmitting,
            handleSubmit,
            setFieldValue,
          }) => (
            <Form onSubmit={handleSubmit}>
              <TextField
                name="password"
                type={!passwordVisibility ? "password" : "text"}
                label="Password"
                variant="outlined"
                value={values?.password}
                fullWidth
                className={classes.textfield}
                onChange={handleChange}
                helperText={touched.password && errors.password}
                error={touched.password && errors.password}
                FormHelperTextProps={{
                  className: classes.formHelperText,
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        edge="end"
                        size="small"
                        onClick={() =>
                          setPasswordVisibility(!passwordVisibility)
                        }
                      >
                        {passwordVisibility ? (
                          <VisibilityOffOutlined
                            fontSize="small"
                            style={{ color: "#898989" }}
                          />
                        ) : (
                          <VisibilityOutlined
                            fontSize="small"
                            style={{ color: "#898989" }}
                          />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                type={!confirmedNewPasswordVisibility ? "password" : "text"}
                name="confirmedPassword"
                label="Confirm New Password"
                variant="outlined"
                value={values?.confirmedPassword}
                fullWidth
                className={classes.textfield}
                onChange={handleChange}
                helperText={
                  touched.confirmedPassword && errors.confirmedPassword
                }
                FormHelperTextProps={{
                  className: classes.formHelperText,
                }}
                error={touched.confirmedPassword && errors.confirmedPassword}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        edge="end"
                        size="small"
                        onClick={() =>
                          setConfirmedNewPasswordVisibility(
                            !confirmedNewPasswordVisibility
                          )
                        }
                      >
                        {confirmedNewPasswordVisibility ? (
                          <VisibilityOffOutlined
                            fontSize="small"
                            style={{ color: "#898989" }}
                          />
                        ) : (
                          <VisibilityOutlined
                            fontSize="small"
                            style={{ color: "#898989" }}
                          />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <DialogActions>
                <Box display="flex" justifyContent="center" width="100%">
                  <Button
                    color="primary"
                    variant="contained"
                    type="submit"
                    style={{ width: "100%" }}
                  >
                    {changePasswordMutation?.isLoading ? (
                      <CircularProgress style={{ color: "#fff" }} size={20} />
                    ) : (
                      "CREATE ACCOUNT"
                    )}
                  </Button>
                </Box>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  )
}

export default FinishAccount
